import type { EmployeeProfileFieldType } from '@hygge/shared';

export interface FieldTypeMeta {
  value: EmployeeProfileFieldType;
  label: string;
  description: string;
}

export const FIELD_TYPE_META: readonly FieldTypeMeta[] = [
  { value: 'SHORT_TEXT', label: 'Single-line text', description: 'Names, IDs, short notes' },
  { value: 'LONG_TEXT', label: 'Multi-line text', description: 'Paragraphs, addresses' },
  { value: 'EMAIL', label: 'Email', description: 'Validated email address' },
  { value: 'PHONE', label: 'Phone', description: 'Free-form phone number' },
  { value: 'URL', label: 'URL', description: 'Link to an external resource' },
  { value: 'NUMBER', label: 'Number', description: 'Integer or decimal' },
  { value: 'DATE', label: 'Date', description: 'Calendar date' },
  { value: 'DROPDOWN', label: 'Dropdown / Single Select', description: 'Pick one of a fixed list' },
  { value: 'CHECKBOX', label: 'Checkbox', description: 'On / Off toggle' },
  { value: 'FILE', label: 'File', description: 'Uploaded document (max 10 MB)' },
];

const META_BY_VALUE = new Map(FIELD_TYPE_META.map((m) => [m.value, m]));

export function getFieldTypeMeta(type: EmployeeProfileFieldType): FieldTypeMeta {
  return META_BY_VALUE.get(type) ?? FIELD_TYPE_META[0];
}
